import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import AntSwitch from "../../../Component/DigitalMarketing/AntSwitch";
import PermissionCheck from "../../../Component/PermissionCheck";
import dele from "../../../assets/DigitalMarketing/image/delete.svg";
import DialogModal from "../../../Component/DigitalMarketing/DialogModal";
import { CategoryLabel } from "./Utils/TableHeadlist";
import { useEffect, useState } from "react";
import edit from "../../../assets/DigitalMarketing/image/edit.svg";

import {
  useAddWellnessCategoryMutation,
  useDeleteWellnessCategoryMutation,
  useGetWellnessCategoryListQuery,
  useGetWellnessCategoryQuery,
  useUpdateWellnessCategoryMutation,
} from "../../../Service/wellnessTips";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../Component/DigitalMarketing/Toast";
import AlertDialog from "../../../Component/DigitalMarketing/deleteConfirmation";
import useDeleteBox from "../../../hooks/digitalMarketing/useDeleteBox";
import TableLoad from "../../../Component/DigitalMarketing/Tableload";
import { validate } from "../../../utils";
import Pagination from "../../../Component/DigitalMarketing/Pagination";

function CategoryList(props) {
  const {
    handleClose,
    open,
    refetch1,
    setOpen,
    setsubmit,
    submit,
    pagi,
    pagination,
    setpagination,
  } = props;
  const initialstate = { id: "", categoryName: "" };
  const [category, setCategory] = useState(initialstate);
  const { open: open1, message, openSnackBar, type } = useSnackbar();
  const [edit, setedit] = useState(false);
  const {
    open: open2,
    message: message2,
    openDelete,
    deleteId,
  } = useDeleteBox();

  const OnChange = (event) => {
    const { name, value } = event.target;
    setsubmit(false);
    setCategory((prevState) => ({ ...prevState, [name]: value }));
  };
  const {
    data: response,
    isLoading,
    refetch,
  }: any = useGetWellnessCategoryListQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });
  console.log(response,"responseresponseresponseresponseresponse");
  const [addWellnessCategory] = useAddWellnessCategoryMutation();
  const [updateWellnessCategory] = useUpdateWellnessCategoryMutation();
  const [deleteWellnessCategory] = useDeleteWellnessCategoryMutation();
  useEffect(() => {
    if (!open) {
      setCategory(initialstate);
    }
  }, [open]);
  const onSubmit = async () => {
    let data = {
      ...category,
    };
    setsubmit(true);
    if (data.categoryName) {
      try {
        const payload = await addWellnessCategory(data).unwrap();
        refetch();
        refetch1();
        openSnackBar("Added successfully");
        handleClose();
      } catch (error: any) {
        openSnackBar(error.data.error, "error");
      }
    } else {
      openSnackBar("Please fill all data before submit!", "error");
    }
  };
  const onSubmit1 = async () => {
    let data = {
      ...category,
    };
    setsubmit(true);
    if (data.categoryName) {
      try {
        const payload = await updateWellnessCategory(data).unwrap();
        refetch();
        refetch1();
        openSnackBar("Added successfully");
        handleClose();
      } catch (error: any) {
        openSnackBar(error.data.error, "error");
      }
    } else {
      openSnackBar("Please fill all data before submit!", "error");
    }
  };
  const Delete = async (bool) => {
    if (bool) {
      try {
        const res = await deleteWellnessCategory(deleteId).unwrap();
        openSnackBar("Deleted successfully");
        refetch();
        refetch1();
      } catch (err: any) {
        openSnackBar(err?.data?.error, "error");
      }
    }
    openDelete("Are you sure you want to delete this Categor?", false, null);
  };
  const onChange = async (id, event, check = false) => {
    if (check) {
      try {
        const payload = await updateWellnessCategory({
          id,
          [event.target.name]: check
            ? event.target.checked
              ? 1
              : 0
            : event.target.value,
        }).unwrap();
        // console.log("fulfilled", payload);
        openSnackBar("Updated successfully");
      } catch (error: any) {
        openSnackBar(error.data.error, "error");
        console.error("rejected", error);
      }
    } else {
      if (validate(event.target.value)) {
        try {
          const payload = await updateWellnessCategory({
            id,
            [event.target.name]: check
              ? event.target.checked
                ? 1
                : 0
              : event.target.value,
          }).unwrap();
          refetch1();

          // console.log("fulfilled", payload);
          openSnackBar("Updated successfully");
        } catch (error: any) {
          openSnackBar(error.data.error, "error");
          console.error("rejected", error);
        }
      }
    }
  };
  return (
    <>
      {" "}
      <AlertDialog open={open2} message={message2} deleteBranches={Delete} />
      <Toast open={open1} type={type} message={message} />
      <DialogModal
        title={edit ? "Edit Category" : "Add Category"}
        formlist={CategoryLabel}
        open={open}
        value={category}
        setedit={setedit}
        submit={submit}
        handleChange={OnChange}
        handleSubmit={edit ? onSubmit1 : onSubmit}
        handleClose={handleClose}
        btnName={edit ? "Update" : "Submit"}
      />
      <div className="table-list">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className="table-head">Category list</TableCell>
              <TableCell className="table-head">Status</TableCell>
              <TableCell className="table-head">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {response?.data &&
              response?.data?.map((a, i) => {
                return (
                  <RenderData
                    a={a}
                    onChange={onChange}
                    openDelete={openDelete}
                    setOpen={setOpen}
                    setedit={setedit}
                    setCategory={setCategory}
                  />
                );
              })}
          </TableBody>
        </Table>

        {isLoading && (
          <div className="d-flex justify-content-center">
            <TableLoad />
          </div>
        )}
        {response?.length === 0 && (
          <div className="d-flex justify-content-center">
            <small className="m-3">No results found!</small>
          </div>
        )}
      </div>
    </>
  );
}

export default CategoryList;

const RenderData = (props) => {
  const { a, onChange, openDelete, setOpen, setedit, setCategory } = props;
  const [val, setVal] = useState(a.categoryName);
  const onHandleEdit = (data) => {
    // console.log(data);

    setedit(data);
    setCategory(data);

    setOpen(true);
  };
  const [checked, setChecked] = useState(a.activeStatus == 1);
  useEffect(() => {
    setVal(a.categoryName);
    setChecked(a.activeStatus == 1);
  }, [a]);
  return (
    <TableRow>
      <TableCell>
        <input
          type="text"
          placeholder="Role Management"
          className="text-custom-contain"
          style={{ border: !validate(val) ? "1px solid red" : "" }}
          name="categoryName"
          value={val}
          onBlur={(e) => onChange(a.id, e)}
          onChange={(e) => setVal(e.target.value)}
        />
      </TableCell>
      <TableCell>
        <AntSwitch
          
          checked={checked}
          onChange={(e) => {
            setChecked(e.target.checked);
            onChange(a.id, e, true);
          }}
          name="activeStatus"
          inputProps={{ "aria-label": "ant design" }}
        />
      </TableCell>
      <TableCell>
        <img
          alt="edit"
          src={edit}
          className="blue-c action-icon cursur me-2"
          onClick={() => onHandleEdit(a)}
        />
        <img
          src={dele}
          alt="delete"
          onClick={() =>
            openDelete(
              "Are you sure you want to delete this Category?",
              true,
              a.id
            )
          }
          className="delete-icon cursur mx-2 action-icon"
        />
      </TableCell>
    </TableRow>
  );
};
